import { render, staticRenderFns } from "./vipEdit.vue?vue&type=template&id=4fc317fd"
import script from "./vipEdit.vue?vue&type=script&lang=js"
export * from "./vipEdit.vue?vue&type=script&lang=js"
import style0 from "./vipEdit.vue?vue&type=style&index=0&id=4fc317fd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports